import { theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${theme.spacing.xl};
`;
